const DropdownTexts = ({ label = "", value = "" }) => {
  return (
    <div className="flex justify-between items-end">
      <p className="font-Apparat font-[500] md:font-[600] text-[12px] md:text-[16px] text-[#42495280] leading-[17px] md:leading-[19.2px] tracking-[-2%]">{label}</p>
      <p className="font-Apparat font-[500] text-[16px] md:text-[20px] leading-[19.2px] md:leading-[30px] tracking-[-2%]">{value}</p>
    </div>
  )
}
export default DropdownTexts;